import { Box, Text } from "@mantine/core";
import { IconUser } from "@tabler/icons-react";
import IconItem from "components/IconItem";

const Drivers: React.FC<{ drivers: string[] }> = ({ drivers }) => {
  if (drivers?.length === 0) {
    return <></>;
  }

  return (
    <Box>
      {drivers?.map((driver, index) => (
        <IconItem key={index} icon={<IconUser />} contentAs="div">
          <Text fz={"sm"} lh={"sm"} lineClamp={1}>
            {driver}
          </Text>
        </IconItem>
      ))}
    </Box>
  );
};

export default Drivers;
